const applyMask = (input) => {
  const maskFormat = input.dataset.maskFormat || '00000.00';
  const decimals = maskFormat.split('.')[1]?.length || 0;
  const maxDigits = maskFormat.replace(/[^0#]/g, '').length;

  const digits = input.value.replace(/\D/g, '').slice(0, maxDigits);
  if (digits.length <= decimals) {
    input.value = digits;
    return;
  }

  input.value = `${digits.slice(0, -decimals)}.${digits.slice(-decimals)}`;
};

export const enableInputMasks = () => {
  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('[data-toggle="input-mask"]');
    if (!input) return;

    applyMask(input);
  });
};
